import axiosInstance from '@/store/axios';
import { rejectErrorApi } from '@/store/helper';

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    getConnectorData({ dispatch }, connector) {
      return axiosInstance.get(`/manager/connector/data/${connector.id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.connector;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    getConnectors({ dispatch }, data) {
      if (!data) {
        // eslint-disable-next-line no-param-reassign
        data = {};
      }

      const params = {
        limit: data.limit || 100,
        offset: data.offset || 0,
        sort: data.sort || '-id',
      };

      return axiosInstance.get('/manager/connector/index', {
        params,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.connectors;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    updateConnector({ dispatch }, connector) {
      return axiosInstance.post('/manager/connector/update', connector)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return true;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    createConnector({ dispatch }, connector) {
      return axiosInstance.post('/manager/connector/create', connector)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return true;
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
